// src/components/Footer.js
import React from "react";

const Footer = ({ language }) => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { en: "About The Academy", ar: "حول الاكاديمية" },
    { en: "Training Programs", ar: "البرامج التدريبية" },
    { en: "Continuing Training", ar: "التدريب المستمر" },
    { en: "AAJ", ar: "مجلة الأكاديمية" },
    { en: "Library", ar: "المكتبة" },
  ];

  // const socialLinks = [
  //   { name: "Facebook", icon: "📘", url: "#" },
  //   { name: "Twitter", icon: "🐦", url: "#" },
  //   { name: "LinkedIn", icon: "💼", url: "#" },
  //   { name: "YouTube", icon: "📺", url: "#" }
  // ];

  return (
    <footer className="bg-gradient-to-r from-green-900 to-green-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mr-3 rtl:mr-0 rtl:ml-3">
                <span className="text-green-800 font-bold text-xl">A</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">Arma Academy</h3>
                <p className="text-green-200 text-sm">
                  {language === "ar"
                    ? "أكاديمية آرما"
                    : "Excellence in Training"}
                </p>
              </div>
            </div>
            <p className="text-green-200 mb-4 max-w-md">
              {language === "ar"
                ? "التفكير والابداع طريقنا للتميز"
                : "Thinking and creativity are our path to excellence"}
            </p>
            {/* <div className="flex space-x-4 rtl:space-x-reverse">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="w-10 h-10 bg-green-700 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors"
                  aria-label={social.name}
                >
                  <span className="text-lg">{social.icon}</span>
                </a>
              ))}
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">
              {language === "ar" ? "روابط سريعة" : "Quick Links"}
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href="#"
                    className="text-green-200 hover:text-white transition-colors"
                  >
                    {language === "ar" ? link.ar : link.en}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">
              {language === "ar" ? "معلومات التواصل" : "Contact Info"}
            </h4>
            <div className="space-y-3 text-green-200">
              <p>📧 arma.academy@armagroupeg.com</p>
              <p>📞 01002222693</p>
              <p>📍 10th of Ramadan - Arma Factories</p>
              <p>🕒 Sun - Thu: 9:00 AM - 5:00 PM</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-green-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-green-300 text-sm mb-4 md:mb-0">
            © {currentYear} Arma Academy.{" "}
            {language === "ar" ? "جميع الحقوق محفوظة" : "All rights reserved"}.
          </p>
          <div className="flex space-x-6 rtl:space-x-reverse text-sm text-green-300">
            {/* <a href="#" className="hover:text-white transition-colors">
              {language === "ar" ? "سياسة الخصوصية" : "Privacy Policy"}
            </a> */}
            {/* <a href="#" className="hover:text-white transition-colors">
              {language === "ar" ? "شروط الاستخدام" : "Terms of Service"}
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
